import React from 'react';
import { Box, Typography } from '@mui/material';
import { ApartmentOutlined } from '@mui/icons-material';

const OrganizationListRow = ({ organization, selected = false, onClick, disabled = false, showTrn = false }) => {
  const trn = organization?.trn || organization?.tax_id;
  const rowRadius = '8px';

  return (
    <Box
      role="button"
      tabIndex={disabled ? -1 : 0}
      onClick={disabled ? undefined : onClick}
      onKeyDown={(event) => {
        if (disabled) {
          return;
        }

        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          onClick?.();
        }
      }}
      sx={{
        display: 'flex',
        alignItems: 'flex-start',
        gap: 1.5,
        px: 1.5,
        py: 1.5,
        borderRadius: rowRadius,
        cursor: disabled ? 'default' : 'pointer',
        bgcolor: selected ? 'primary.main' : 'transparent',
        color: selected ? 'primary.contrastText' : 'text.primary',
        opacity: disabled ? 0.6 : 1,
        transition: 'background-color 0.15s ease',
        '&:hover': disabled
          ? {}
          : {
              bgcolor: selected ? 'primary.main' : 'action.hover',
              borderRadius: rowRadius,
            },
      }}
    >
      <ApartmentOutlined
        sx={{
          fontSize: 20,
          mt: 0.25,
          color: selected ? 'inherit' : 'action.active',
        }}
      />
      <Box sx={{ minWidth: 0, flex: 1 }}>
        <Typography
          variant="body2"
          sx={{
            fontWeight: selected ? 700 : 600,
            lineHeight: 1.4,
            color: 'inherit',
          }}
        >
          {organization.name}
        </Typography>
        {showTrn && trn ? (
          <Typography
            variant="caption"
            sx={{
              display: 'block',
              mt: 0.25,
              color: selected ? 'primary.contrastText' : 'text.secondary',
              opacity: selected ? 0.85 : 1,
            }}
          >
            TRN: {trn}
          </Typography>
        ) : null}
      </Box>
    </Box>
  );
};

export default OrganizationListRow;
